type TaxPlanComingSoonCardProps = {
  financialYearLabel: string
}

export function TaxPlanComingSoonCard({ financialYearLabel }: TaxPlanComingSoonCardProps) {
  return (
    <div className='relative z-0 mt-4 flex items-stretch overflow-hidden rounded-[16px] bg-[#FFF2DF] p-4'>
      <div className='relative z-[1] flex min-w-0 flex-1 items-center pr-[120px]'>
        <p className='text-[14px] font-[400] leading-[1.5] text-[#992E00]'>
          Tax-saving plan for this {financialYearLabel} will be available soon.
        </p>
      </div>
      <div aria-hidden='true' className='pointer-events-none absolute inset-y-0 right-0 z-[-1] flex items-center justify-end'>
        <img
          src='/images/tax-harvesting/tax-calendar.png'
          alt=''
          className='h-[66px] w-auto object-contain'
        />
      </div>
    </div>
  )
}
